export const ADDRESS_LIST_ATTEMPT = "ADDRESS_LIST_ATTEMPT";
export const ADDRESS_LIST_SUCCESS = "ADDRESS_LIST_SUCCESS";
export const ADDRESS_LIST_FAILED = "ADDRESS_LIST_FAILED";
///////////////////////////
export const ADDRESS_SAVE_ATTEMPT = "ADDRESS_SAVE_ATTEMPT";
export const ADDRESS_SAVE_SUCCESS = "ADDRESS_SAVE_SUCCESS";
export const ADDRESS_SAVE_FAILED = "ADDRESS_SAVE_FAILED";
